import { ComponentsOverrides, createTheme, Theme } from '@mui/material';

const defaultTheme = createTheme();

export const ToolbarStyles:  ComponentsOverrides<Theme>['MuiToolbar'] =
  {
    root: {
      [defaultTheme.breakpoints.down('md')]: {
        padding: '0.5rem 1rem !important',
      },
    }
  }